import { render, staticRenderFns } from "./Planner.vue?vue&type=template&id=5104cd49&scoped=true"
import script from "./Planner.vue?vue&type=script&lang=js"
export * from "./Planner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5104cd49",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5104cd49')) {
      api.createRecord('5104cd49', component.options)
    } else {
      api.reload('5104cd49', component.options)
    }
    module.hot.accept("./Planner.vue?vue&type=template&id=5104cd49&scoped=true", function () {
      api.rerender('5104cd49', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/posts/Planner.vue"
export default component.exports